import _ from "underscore"
import TemplateView from "../../TemplateView"
import {TaskDialogs, TasksTabs, ValidationErrors} from "./constants"
import messageResource from "../../messageResource"
import UserTime from "../../user_time"
import NameInput from "../NameInput"
import {atImgPath} from "../../atBrowserUtils"
import EditActionButton from '../../controls/task/EditActionButton'
import {EntityTextLimits} from 'constants'

export default class Header extends TemplateView {
    constructor($containerEl, $panel, {
        editable = false,
        showActions = false,
        showReportTab = false,
        showEmptyNameInput = false,
        onChangeNameCb = () => {},
        onTabSwitchedCb = () => {},
    }) {
        super($containerEl)
        this.$panel = $panel;
        this.params = {
            showActions,
            showReportTab,
            editable,
            showEmptyNameInput,
        }

        this.callbacks = {
            onChangeNameCb,
            onTabSwitchedCb,
        }

        this.state = {
            name: '',
            projectName: '',
            customerName: '',
            nameLoading: false,
            errors: {},
            editable: this.params.editable,
            isNeedInitializeFocus: false,
        }

        this.onStatePropertyChanged('isNeedInitializeFocus', (isNeedInitializeFocus) => {
            this.taskNameInput.setState({isNeedInitializeFocus: isNeedInitializeFocus})
        })

        this.onStatePropertyChanged('errors', (errors) => {
            if (!!errors[ValidationErrors.TASK_NAME_DUPLICATE]) {
                this.taskNameInput.setState({
                    invalid: true,
                    focus: true,
                    errorText: messageResource.getMessage("task.edit_popup.duplicate"),
                })
            } else if (!!errors[ValidationErrors.TASK_NAME_EMPTY]) {
                this.taskNameInput.setState({
                    invalid: true,
                    focus: true,
                    errorText: messageResource.getMessage('task.edit_popup.empty'),
                })
            } else {
                this.taskNameInput.setState({
                    invalid: false,
                })
            }
        })

        this.onStatePropertyChanged('name', name => {
            this.taskNameInput.setState({
                name,
                focus: !name,
            })
        })

        this.onStatePropertyChanged('nameLoading', loading => {
            this.taskNameInput.setLoading(loading)
        })

        this.onStatePropertyChanged('projectName', name => {
            this.$projectName.text(name)
        })

        this.onStatePropertyChanged('customerName', name => {
            this.$customerName.text(name)
        })

        this.onStatePropertyChanged('editable', editable => {
            this.actions.toggle(editable && this.params.showActions)
            this.taskNameInput.setState({editable})
        })
    }

    templateHtml() {
        return "<div class='header'>" +
               "  <div class='cpInfo'>" +
               "   <span class='customerName ellipsis'/><img src='<%=separatorArrow%>' class='separator'/><span class='projectName ellipsis'/>" +
               "  </div>" +
               "  <div class='taskNamePlaceholder'/>" +
               "  <div class='actions'></div>" +
               "  <div class='tabs'>" +
               "    <div class='details'><span class='tabText'><%=detailsTab%></span></div>" +
               "    <div class='reportedTime'><span class='tabText'><%=reportedTimeTab%></span></div>" +
               "    <div class='assignedUsers'><span class='tabText'><%=assignedUsersTab%></span></div>" +
               "    <div class='managers'><span class='tabText'><%=managersTab%></span></div>" +
               "    <div class='budgets'><span class='tabText'><%=budgetsTab%></span></div>" +
               "  </div>" +
               "</div>"
    }

    shouldUpdateOnInit() {
        return false;
    }

    messageKeys() {
        return {
            detailsTab: 'task.edit_panel.tabs.details',
            reportedTimeTab: 'task.edit_panel.tabs.reportedTime',
            assignedUsersTab: 'task.edit_panel.tabs.assigned_users',
            managersTab: 'task.edit_panel.tabs.managers',
            budgetsTab: 'task.edit_panel.tabs.budgets'
        };
    }

    templateModel() {
        return {separatorArrow: atImgPath('taskManagement/arrow.png')};
    }

    afterRender() {
        this.$projectName = this.find('.projectName');
        this.$customerName = this.find('.customerName');
        this.$tabs = [];
        this.$tabs[TasksTabs.DETAILS_TAB] = this.find('.details');
        this.$tabs[TasksTabs.REPORTED_TAB] = this.find('.reportedTime');
        this.$tabs[TasksTabs.ASSIGNED_USERS_TAB] = this.find('.assignedUsers');
        this.$tabs[TasksTabs.MANAGERS_TAB] = this.find('.managers');
        this.$tabs[TasksTabs.BUDGETS] = this.find('.budgets');
        this.$assignedUsersTabTitle = this.find(".assignedUsers .tabText");
        this.$managersTabTitle = this.find(".managers .tabText");
        this.taskNameInput = new NameInput({
            editable: this.params.editable,
            placeholder:messageResource.getMessage('task.edit_popup.name_placeholder'),
            maxLength: EntityTextLimits.MAX_CPT_NAME,
            showEmptyInput: this.params.showEmptyNameInput,
            onChangeCb: this.callbacks.onChangeNameCb,
        }).init(this.$containerEl.find('.taskNamePlaceholder'));

        this.actions = new EditActionButton({
            panelEl: this.$panel,
            headerEl: this.$containerEl,
            needMove: true,
            needCopy: true,
            needDelete: true,
            onDeleteCb: () => this.callbacks.onTabSwitchedCb(TaskDialogs.DELETE_DIALOG),
            onMoveCb: () => this.callbacks.onTabSwitchedCb(TaskDialogs.MOVE_DIALOG),
            onCopyCb: () => this.callbacks.onTabSwitchedCb(TaskDialogs.COPY_DIALOG),
        }).init(this.$containerEl.find('.actions'))

        for (let tabKey of Object.values(TasksTabs)) {
            this.$tabs[tabKey].click(() => this.callbacks.onTabSwitchedCb(tabKey))
        }

        this.$tabs[TasksTabs.REPORTED_TAB].toggle(this.params.showReportTab)

        this.renderInitialState()
    }

    updateActions(config) {
        this.actions.disableDeleteButton(this.disableDeleteButtonText(config));
    }

    disableDeleteButtonText(config) {
        let disableText = null;
        if (config.blockedDueToLockedTime) {
            disableText = messageResource.getMessage('task.edit_popup.cannot_delete_due_to_lock_time');
        } else if (config.blockedDueToUnavailableToModifyTimeTrack) {
            const text = messageResource.getMessage('common.task');
            disableText = messageResource.getMessage(config.canManageAllUsersWithoutAutoApproved ? 'hierarchy_entity.edit_popup.cannot_delete_due_to_unavailable_modify_time_of_autoapproved_users' : 'hierarchy_entity.edit_popup.cannot_delete_due_to_unavailable_modify_time', [text]);
        }
        return disableText;
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/task/Header.js